export default __webpack_public_path__ + "static/media/home.e2fb6025.jpg";